import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import TextField from '@mui/material/TextField'

const HSActions = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  return (
    <TextField
      value={formValues?.incident?.healthSafetyImmediateActionTaken}
      onChange={(e) =>
        handleChange({
          moduleName: 'incident',
          field: 'healthSafetyImmediateActionTaken',
          value: e.target.value,
        })
      }
      label="Immediate Action Taken"
      multiline
    />
  )
}

export default HSActions
